import React from 'react'

import { ZariContext } from '_zari/context'

import { Form, Col, Button } from '_zari/core'

import * as SocioCrud from 'services/socio.service'

import CrudPlacasModal from './modals/crudPlacas'

const PlacaSocioFormGroup = ({
  idSocio,
  idPlacaSocio,
  flagEditarComentarios,
  index,
  keyUpPlacaHandler,
  keyDownPlacaHandler,
  autoFocus,
  changePlacaHandler
}) => {
  const __zariContext = React.useContext(ZariContext)

  const [placas, setPlacas] = React.useState([])
  const [mostrarCrudPlacasModal, setMostrarCrudPlacasModal] = React.useState(false)

  React.useEffect(() => {
    if (idSocio === '') {
      setPlacas([])
    } else {
      SocioCrud.obtenerPlacasxIdSocioAsSelect(idSocio)
        .then(({ data }) => {
          setPlacas(data)
        })
        .catch(({ data: { error } }) => __zariContext.snack('error', error))
    }
  }, [idSocio, __zariContext])

  const clickMostrarCrudPlacasModalHandler = e => {
    e.preventDefault()
    setMostrarCrudPlacasModal(true)
  }

  const refrescarListaPlacasHandler = React.useCallback(() => {
    SocioCrud.obtenerPlacasxIdSocioAsSelect(idSocio)
      .then(({ data }) => {
        setPlacas(data)
      })
      .catch(({ data: { error } }) => __zariContext.snack('error', error))
  }, [idSocio, __zariContext])

  return (
    <>
      <Form.Group>
        <Col md={12}>
          <Form.InputGroup>
            <Form.Select
              id={`select-idPlacaSocio-${index}`}
              name={`select-idPlacaSocio-${index}`}
              disabled={idSocio === '' || flagEditarComentarios}
              value={idPlacaSocio}
              onChange={changePlacaHandler}
              onKeyUp={keyUpPlacaHandler}
              onKeyDown={keyDownPlacaHandler}
              autoFocus={autoFocus}
            >
              <option value=''>Seleccionar</option>
              {placas.map((val, key) => (
                <option key={key} value={val._id}>
                  {val.placa}
                </option>
              ))}
            </Form.Select>
            {!flagEditarComentarios && (
              <Form.InputGroup.Append>
                <Button disabled={idSocio === ''} onClick={clickMostrarCrudPlacasModalHandler}>
                  &#x2b;
                </Button>
              </Form.InputGroup.Append>
            )}
          </Form.InputGroup>
        </Col>
      </Form.Group>
      {mostrarCrudPlacasModal && (
        <CrudPlacasModal
          handleClose={e => setMostrarCrudPlacasModal(false)}
          show={mostrarCrudPlacasModal}
          _idSocio={idSocio}
          refrescarListaPlacasHandler={refrescarListaPlacasHandler}
        />
      )}
    </>
  )
}

export default React.memo(PlacaSocioFormGroup)
